@if (user().fullName) {
  <app-side-menu #sideMenu>
    <ng-container sideMenuHeader>
      <div class="flex items-center min-h-[100px] pr-5">
        <app-icon class="close-button" name="heroXMark"
                  (click)="sideMenu.sidenav().toggle()"></app-icon>
        <a class="avatar-wrapper side-menu-header-container" (click)="sideMenu.sidenav().toggle()" [routerLink]="['/' + routePath.myProfile]">
          <app-avatar-container class="avatar-md" [name]="user().fullName"></app-avatar-container>
          <app-title class="text-xl ml-2" [title]="user().fullName" [subtitle]="user().userName"></app-title>
        </a>
      </div>
    </ng-container>

    <nav class="header-container shadow-xl shadow-gray-100">
      <div class="user-info-container">
        <app-icon class="mr-6 ml-6 pr-6` border-gray-300 text-gray cursor-pointer" name="heroBars3BottomLeft"
                  (click)="sideMenu.sidenav().toggle()"></app-icon>
        <a class="avatar-wrapper" [routerLink]="['/' + routePath.myProfile]">
          <app-avatar-container class="avatar-md" [name]="user().fullName"></app-avatar-container>
          <app-title class="text-xl ml-2" [title]="user().fullName" [subtitle]="user().userName"></app-title>
        </a>
      </div>
      <div class="items-center justify-between hidden md:hidden w-full xl:flex xl:w-auto">
        <ul class="flex p-4 md:p-0 md:space-x-8 xl:space-x-12 text-primary-gray">
          <li>
            <a [routerLink]="[routePath.myHistory]" routerLinkActive="text-blue-light"
               class="flex items-center cursor-pointer">
              <app-icon class="mr-1" name="heroSquare3Stack3d"></app-icon>
              MyHistory
            </a>
          </li>
          <li>
            <a class="flex items-center">
              <app-icon class="mr-1" name="heroUsers"></app-icon>
              Communities
            </a>
          </li>
          <li>
            <a class="flex items-center">
              <app-icon class="mr-1" name="heroPhoto"></app-icon>
              My Feed
            </a>
          </li>
          <li>
            <a class="flex items-center">
              <app-icon class="mr-1" name="heroBell"></app-icon>
              Notifications
            </a>
          </li>
        </ul>
      </div>
      <app-add-story></app-add-story>
<!--      <div class="max-w-screen-3xl flex flex-wrap items-center justify-between mx-auto p-4  min-h-[100px]">-->
<!--      </div>-->
    </nav>

    <div class="content-container bg-gradient-to-b from-white from-25% to-85% to-gray-lighten">
      <ng-content></ng-content>
    </div>

  </app-side-menu>
}

<ng-container *ngIf="!user().fullName">
  <app-guest-header>
    <router-outlet></router-outlet>
  </app-guest-header>
</ng-container>
